<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/index/bg2.png" />
      <div>查看预约</div>
    </div>
    <div class="mobileBox" v-if="first">
      <div class="title">
        请准确填写申请车证时的手机号，如填写错误，将无法找回证件
      </div>
      <div class="itemBox">
        <div class="leftBox">
          <span>*</span>
          <span>手机号</span>
        </div>
        <input placeholder="请输入手机号" v-model="mobile" />
      </div>
      <div class="nextBtn" @click="submitHandle">提交信息</div>
    </div>
    <div class="listBox" v-else>
      <div
        class="listItem"
        v-for="(item, index) in list"
        :key="index"
        @click="showPopup(item)"
      >
        <div class="one">
          <span>货车进馆申请记录</span>
          <span class="iconfont icon-arrow-down"></span>
        </div>
        <div class="name">司机：{{ item.DriverName }}</div>
        <div class="name">进馆时间：{{ item.ApplyDate | formatTime }}</div>
      </div>
      <div v-if="list.length == 0" class="kongIcon">
        <span class="iconfont icon-kong"></span>
        <div>该手机号暂无申请记录</div>
      </div>
    </div>
    <van-popup v-model="show">
      <div class="showBox">
        <div class="title">申请记录</div>
        <div class="contentBox">
          <div>
            <span>展位号：</span>
            <span>{{ info.PlaceNo }}</span>
          </div>
          <div>
            <span>展区：</span>
            <span>{{ info.Region }}区</span>
          </div>
          <div>
            <span>展馆：</span>
            <span>{{ info.HallNo }} </span>
          </div>
          <div>
            <span>参展企业：</span>
            <span>{{ info.CompanyNameChi }}</span>
          </div>
          <div>
            <span>车牌号：</span>
            <span>{{ info.CarNum }}</span>
          </div>
          <div>
            <span>货车类型：</span>
            <span>{{ info.CarType }}</span>
          </div>
          <div>
            <span>司机姓名：</span>
            <span>{{ info.DriverName }}</span>
          </div>
          <div>
            <span>身份证：</span>
            <span>{{ info.IdCard }}</span>
          </div>
          <div>
            <span>车辆种类：</span>
            <span>{{ info.ApplyType }}</span>
          </div>
          <div>
            <span>进馆时间：</span>
            <span>{{ info.ApplyDate | formatTime }}</span>
          </div>
          <div>
            <span>手机号：</span>
            <span>{{ info.Mobile }}</span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Popup, Toast } from "vant";
import { formatTimeDay } from "@/utils/date.js";
import { getExhibitionCarRecords } from "@/api/index";
export default {
  name: "viewOrder",
  components: {
    "van-popup": Popup,
    Toast,
  },
  filters: {
    formatTime(time) {
      let date = new Date(time);
      return formatTimeDay(date, "yyyy-MM-dd");
    },
  },
  data() {
    return {
      mobile: "",
      show: false,
      list: [],
      info: "",
      first: false,
    };
  },
  methods: {
    showPopup(item) {
      this.show = true;
      this.info = item;
    },

    //提交信息
    submitHandle() {
      var that = this;
      if (that.mobile == "") {
        Toast("请填写正确的手机号");
        return false;
      }
      getExhibitionCarRecords({ Mobile: that.mobile }).then((res) => {
        that.first = false;
        that.list = res.Data;
      });
    },
  },
  mounted() {
    if (this.$route.query.mobile) {
      getExhibitionCarRecords({ Mobile: this.$route.query.mobile }).then(
        (res) => {
          this.first = false;
          this.list = res.Data;
        }
      );
    } else {
      this.first = true;
    }
  },
};
</script>
<style lang="less" scoped>
.top-box {
  width: 375px;
  height: 104px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  div {
    position: absolute;
    z-index: 1;
    bottom: 40px;
    left: 50%;
    transform: translate(-50%, 0);
    color: #fff;
    font-size: 23px;
    font-weight: bold;
  }
}
.mobileBox {
  margin: 17px 20px;
  .title {
    color: #333;
    font-size: 14px;
  }
  .itemBox {
    font-size: 14px;
    display: flex;
    align-items: center;
    flex-direction: row;
    border: 1px solid #ddd;
    height: 45px;
    line-height: 45px;
    margin-top: 10px;
    border-radius: 5px;
    .leftBox {
      width: 80px;
      text-align: right;
      span {
        &:first-child {
          color: #c00b0b;
          margin-right: 5px;
        }
      }
    }
    input {
      height: 35px;
      line-height: 35px;
      width: 220px;
      border: none;
      margin-left: 15px;
    }
    .forgetButton {
      font-size: 12px;
      width: 84px;
      height: 32px;
      line-height: 32px;
      box-sizing: border-box;
      background-color: #eb4e4e;
      border: none;
      color: #fff;
      border-radius: 4px;
    }
    .iconfont {
      color: #666;
      font-size: 14px;
      margin-right: 10px;
    }
  }
  .nextBtn {
    font-size: 18px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #ffff;
    background-color: #eb4e4e;
    border-radius: 22px;
    margin-top: 20px;
  }
}
.listBox {
  margin: 21px 20px 0px 20px;
  padding-bottom: 50px;
  .listItem {
    border: 1px solid #ccc;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 19px 12px 5px 10px;
    margin-bottom: 15px;
    .one {
      font-size: 15px;
      color: #333;
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      .iconfont {
        font-size: 14px;
      }
    }
    .name {
      font-size: 13px;
      color: #555;
      margin-bottom: 10px;
    }
  }
}
.showBox {
  width: 303px;
  background: #ffffff;
  font-size: 16px;
  padding: 18px 16px;
  .title {
    font-size: 17px;
    color: #333;
    font-weight: bold;
    text-align: center;
  }
  .contentBox {
    margin-top: 22px;
    font-size: 16px;
    color: #666;
    div {
      display: flex;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0px;
      }
      span {
        &:first-child {
          display: block;
          width: 90px;
        }
        &:last-child {
          color: #333;
        }
      }
    }
  }
}
/deep/ .van-popup {
  border-radius: 12px;
}
.kongIcon {
  color: #999999;
  font-size: 13px;
  text-align: center;
  margin: 100px 0px;
  .iconfont {
    font-size: 86px;
  }
}
</style>